<template>
  <div
    class="recommended-reading-teaser"
    :class="{ 'recommended-reading-teaser--draft': post.status === 'draft' }"
  >
    <app-link
      :to="link"
      class="recommended-reading-teaser__link link link--unstyled"
    >
      <img
        v-if="hasFeaturedImage(post)"
        :src="teaserImage(post)"
        :alt="post.featuredMedia[0].alt || `${post.title} image`"
        loading="lazy"
        class="recommended-reading-teaser__image"
      >
      <h3 class="recommended-reading-teaser__title">{{ post.title }}</h3>
    </app-link>
  </div>
</template>

<script>
import AppLink from '@/components/Global/AppLink.vue';
import postTeaserMixin from '@/mixins/post-teaser-mixin';

export default {
  name: 'RecommendedReadingTeaser',
  components: { AppLink },
  mixins: [postTeaserMixin],
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  methods: {
    hasFeaturedImage(post) {
      return !!post.featuredMedia && !!post.featuredMedia[0];
    },
    teaserImage(post) {
      if (post.featuredMedia && post.featuredMedia[0]) {
        return post.featuredMedia[0].urlRecommended || post.featuredMedia[0].url;
      }

      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_recommended-reading-teaser';
</style>
